import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { PortfolioAccountAssignmentDialogComponent } from '@irb/irb-create-portfolio/portfolio-account-assignment-dialog/portfolio-account-assignment-dialog.component';
import { UtilityService } from '@irb-common/services/utility.service';
import { TruncateTooltipCellComponent } from '@irb-common/components/grid/renderers/truncatetooltip.cell.component';
import { IrbAgSearchMultipleColumnFilterComponent } from '@irb/irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-search-multiple-column-filter/irb-ag-search-multiple-column-filter.component';

@Injectable({
    providedIn: 'root'
})
export class PortfolioAccountAssignmentGridLayoutService implements GridLayoutService<PortfolioAccountAssignmentDialogComponent> {
    constructor(private util: UtilityService) {}

    getFrameworkComponents() {
        return {
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent
        };
    }

    getColumnDefs(parent: PortfolioAccountAssignmentDialogComponent) {
        return [{
            headerName: 'Select All',
            headerComponent: 'customHeader',
            cellRenderer : 'customHeader',
            cellRendererParams: {parentObject: parent, type: 'rowCheckBox' },
            suppressColumnsToolPanel: true,
            suppressSizeToFit: true,
            toolPanelClass: 'toolpanel-header-checkbox-hide',
            headerComponentParams: {parentObject: parent, type: 'headerCheckBox' },
            floatingFilterComponent: 'customHeader',
            floatingFilterComponentParams: { parentObject: parent, type: 'clearAllBtn' },
            suppressFloatingFilterButton: true,
            suppressMovable: true,
            lockPosition: true,
            lockVisible: true,
            sortable: false,
            filter: true,
            resizable: false,
            minWidth: 25,
            width: 25,
            maxWidth:25,
            cellStyle: {'padding' : '5px 3px 0 2px'},
            headerClass: 'customHeaderClassSelectAll',
            cellClass: 'selectAllCheckBoxRecord'
        },{
            headerName: 'Acct#',            
            field: 'accountNumber',
            maxWidth: 144,
            width: 144,
            floatingFilterComponent: 'irbInputFloatingFilterComponent',
            filter: 'irbAgSearchMultipleColumnFilterComponent',
             filterParams: {
                search: (str: string, d: IrbAgSearchMultipleColumnFilterComponent) => parent.getUnassignedAccountNumber(str, d),
                threshold: 3,
                field: "accountNumber",
                enableHiddenSearchResults: true
          },
        },
        {
            headerName: 'Name',
            field: 'accountName',
            minWidth: 90,
            cellRenderer: "TruncateTooltipCellComponent",
            floatingFilterComponent: 'irbInputFloatingFilterComponent',
            filter: 'irbAgSearchMultipleColumnFilterComponent',
            filterParams: {
                search: (str: string, d: IrbAgSearchMultipleColumnFilterComponent) => parent.getUnassignedAccountName(str, d),
                threshold: 2,
                field: "accountId",
                displayField: "name",
                enableHiddenSearchResults: true
            },
        },
        {
            headerName: 'Value',
            field: 'marketValue',
            maxWidth: 144,
            width: 144,
            cellRenderer : 'cellRendererFormatter',
            cellRendererParams: {type: 'currency'}
        },
        {
            headerName: 'Type',
            field: 'accountType',
            maxWidth: 144,
            width: 144,
            cellRenderer: "TruncateTooltipCellComponent"
        },
        {
            headerName: 'Taxability',
            field: 'accountLocationType',
            maxWidth: 144,
            width: 144
        },
        {
            headerName: 'Date Opened',
            field: 'accountOpeningDate',
            maxWidth: 144,
            width: 144,
            cellRenderer : 'cellRendererFormatter',
            cellRendererParams: {type: 'date', format: 'MM/dd/yyyy' , enablePointer: true}
        },
        {
            headerName: 'Master Account',
            field: 'masterAccount',
            maxWidth: 194,
            width: 194,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ['reset', 'apply'],
                values: (params: any) => {
                    params.success(parent.masterNumberList);
                },
                newRowsAction: 'keep',
                suppressSorting: true,
                cellHeight: 30,
                closeOnApply: true,
                refreshValuesOnOpen: true
            }
        }];
    }
}
